import React from 'react';
import { Box } from '@mui/material';
import theme from 'theme/theme';
import { Model } from '../../hooks/useModelState';
import PCSpool from '../../MineModel/Spools/PCSpool';
import getWearMonitoringSceneActions from './WearMonitoringSceneActions';
import { SceneProps } from '../scene-utils';
import ModelDrawerTrigger from '../../ModelDrawerTrigger';
import { Scene } from '../types';
import sideDrawerContentFunction from './WearMonitoringSideDrawer';
import { IntersectionData } from '../../MineModel/intersectionTypes';

const TITLE = 'WEAR MONITORING SCENE';

const WearMonitoringSceneDisplay = ({ props }: { props: SceneProps }) => (
  <>
    {!props.context.state.drawerOpen && (
      <Box
        sx={{ position: 'absolute', right: theme.spacing(2), zIndex: 20 }}
      >
        <ModelDrawerTrigger handleClick={() => props.context.actions.setDrawerOpen(true)} />
      </Box>
    )}
  </>
);

// An inspection point measures a length of pipe, so the thing a user picks in this scene is a spool.
const selectSpool = (model: Model, spool: PCSpool) => {
  model.setSelectedSpool(model.spools[spool.spoolId] ?? spool);
};

const wearMonitoringScene = (props: SceneProps): Scene => {
  const display = () => (
    <WearMonitoringSceneDisplay props={props} />
  );

  const getCanvasHandlers = (model: Model) => ({
    onNodeHover: () => { },
    onNodeSelect: () => { },
    onSpoolSelect: (spool: PCSpool) => {
      selectSpool(model, spool);
    },
    // Same rule as the default scene: a click near a node lands on the node, and only a click on bare
    // pipe picks the spool. A node click here does nothing - there is nothing to anchor to a node.
    onIntersections: (intersections: IntersectionData[]) => {
      const nodeIntersection = intersections.find((intersection) => intersection.type === 'node');
      if (nodeIntersection) return;

      const spoolIntersection = intersections.find((intersection) => intersection.type === 'spool' && intersection.spool);
      if (spoolIntersection?.spool) {
        selectSpool(model, spoolIntersection.spool);
      }
    },
  });

  const sideDrawerContent = (model: Model) => sideDrawerContentFunction(props, model);

  const onExit = (model: Model) => {
    model.setSelectedSpool(undefined);
    model.clearAllInspectionPoints();
    model.clearAllPipeColors();
  };

  return {
    key: props.key,
    display,
    getCanvasHandlers,
    sideDrawerContent,
    onExit,
    title: TITLE,
    actionButtons: getWearMonitoringSceneActions(),
  };
};

export default wearMonitoringScene;
